module.exports = __webpack_public_path__ + "static/media/aws.cdd13b54.png";